"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from "react";
import type { ApiWave } from "@/generated/models/ApiWave";
import MyStreamWaveDesktopTabs from "../MyStreamWaveDesktopTabs";
import { useContentTab } from "@/components/brain/ContentTabContext";
import MemesArtSubmissionModal from "@/components/waves/memes/MemesArtSubmissionModal";
import MyStreamWaveTabsMemeSubmit from "./MyStreamWaveTabsMemeSubmit";
import { useWave } from "../../../../hooks/useWave";
import { useDecisionPoints } from "../../../../hooks/waves/useDecisionPoints";
import { Time } from "../../../../helpers/time";
import type { TimeLeft } from "../../../../helpers/waves/time.utils";
import { calculateTimeLeft } from "../../../../helpers/waves/time.utils";
import { CompactTimeCountdown } from "../../../waves/leaderboard/time/CompactTimeCountdown";
import { useSidebarState } from "../../../../hooks/useSidebarState";
import { ChevronDoubleLeftIcon, ArrowLeftIcon, MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import WavePicture from "../../../waves/WavePicture";
import { useRouter, useSearchParams, usePathname } from "next/navigation";
import { createBreakpoint } from "react-use";
import WaveDropsSearchModal from "@/components/waves/drops/search/WaveDropsSearchModal";
import { MyStreamWaveTab } from "@/types/waves.types";
import { useWaveChatScrollOptional } from "@/contexts/wave/WaveChatScrollContext";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { getWaveHomeRoute } from "@/helpers/navigation.helpers";
const useBreakpoint = createBreakpoint({
  LG: 1024,
  S: 0
});
interface MyStreamWaveTabsMemeProps {
  readonly wave: ApiWave;
}
const MyStreamWaveTabsMeme: React.FC<MyStreamWaveTabsMemeProps> = t0 => {
  const $ = _c(74);
  const {
    wave
  } = t0;
  const {
    activeContentTab,
    setActiveContentTab
  } = useContentTab();
  const {
    toggleRightSidebar,
    isRightSidebarOpen
  } = useSidebarState();
  const [isMemesModalOpen, setIsMemesModalOpen] = useState(false);
  const router = useRouter();
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const {
    isApp
  } = useDeviceInfo();
  const breakpoint = useBreakpoint();
  const isMobile = breakpoint === "S";
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const waveChatScroll = useWaveChatScrollOptional();
  const {
    isMemesWave,
    isRankWave,
    pauses: t1
  } = useWave(wave);
  const {
    filterDecisionsDuringPauses
  } = t1;
  const {
    allDecisions
  } = useDecisionPoints(wave);
  let t2;
  if ($[0] !== allDecisions || $[1] !== filterDecisionsDuringPauses) {
    const decisionsAsApiFormat = allDecisions.map(_temp);
    const filtered = filterDecisionsDuringPauses(decisionsAsApiFormat);
    t2 = allDecisions.filter(decision_0 => filtered.some(f => f.decision_time === decision_0.timestamp));
    $[0] = allDecisions;
    $[1] = filterDecisionsDuringPauses;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const filteredDecisions = t2;
  let t3;
  if ($[3] !== filteredDecisions) {
    t3 = filteredDecisions.find(_temp2)?.timestamp ?? null;
    $[3] = filteredDecisions;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const nextDecisionTime = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const [timeLeft, setTimeLeft] = useState(t4);
  let t5;
  let t6;
  if ($[6] !== nextDecisionTime) {
    t5 = () => {
      if (!nextDecisionTime) {
        return;
      }
      setTimeLeft(calculateTimeLeft(nextDecisionTime));
      const intervalId = setInterval(() => {
        const newTimeLeft = calculateTimeLeft(nextDecisionTime);
        setTimeLeft(newTimeLeft);
        if (newTimeLeft.days === 0 && newTimeLeft.hours === 0 && newTimeLeft.minutes === 0 && newTimeLeft.seconds === 0) {
          clearInterval(intervalId);
        }
      }, 1000);
      return () => clearInterval(intervalId);
    };
    t6 = [nextDecisionTime];
    $[6] = nextDecisionTime;
    $[7] = t5;
    $[8] = t6;
  } else {
    t5 = $[7];
    t6 = $[8];
  }
  useEffect(t5, t6);
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      setIsMemesModalOpen(true);
    };
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const handleMemesSubmit = t7;
  let t8;
  if ($[10] !== isApp || $[11] !== router || $[12] !== searchParams || $[13] !== wave.chat.scope.group?.is_direct_message) {
    t8 = () => {
      const params = new URLSearchParams(searchParams?.toString() || "");
      params.delete("wave");
      params.delete("serialNo");
      params.delete("divider");
      params.delete("drop");
      const basePath = getWaveHomeRoute({
        isDirectMessage: wave.chat.scope.group?.is_direct_message ?? false,
        isApp
      });
      const newUrl = params.toString() ? `${basePath}?${params.toString()}` : basePath;
      router.push(newUrl, {
        scroll: false
      });
    };
    $[10] = isApp;
    $[11] = router;
    $[12] = searchParams;
    $[13] = wave.chat.scope.group?.is_direct_message;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const handleMobileBack = t8;
  let t9;
  if ($[15] !== pathname || $[16] !== router || $[17] !== searchParams || $[18] !== setActiveContentTab || $[19] !== wave.id || $[20] !== waveChatScroll) {
    t9 = serialNo => {
      setActiveContentTab(MyStreamWaveTab.CHAT);
      if (waveChatScroll) {
        waveChatScroll.requestScrollToSerialNo({
          waveId: wave.id,
          serialNo
        });
        return;
      }
      const params_0 = new URLSearchParams(searchParams?.toString() || "");
      params_0.set("serialNo", String(serialNo));
      router.replace(`${pathname}?${params_0.toString()}`, {
        scroll: false
      });
    };
    $[15] = pathname;
    $[16] = router;
    $[17] = searchParams;
    $[18] = setActiveContentTab;
    $[19] = wave.id;
    $[20] = waveChatScroll;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  const handleSearchSelect = t9;
  let t10;
  if ($[22] !== handleMobileBack || $[23] !== isMobile) {
    t10 = isMobile && <button onClick={handleMobileBack} className="-tw-ml-2.5 tw-mr-1.5 tw-flex tw-h-full tw-items-center tw-border-0 tw-bg-transparent tw-p-0 tw-px-2.5 tw-text-iron-300 tw-transition-colors hover:tw-text-iron-50" aria-label="Go back"><ArrowLeftIcon className="tw-h-6 tw-w-6 tw-flex-shrink-0" /></button>;
    $[22] = handleMobileBack;
    $[23] = isMobile;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== isMobile || $[26] !== wave.contributors_overview || $[27] !== wave.name || $[28] !== wave.picture) {
    t11 = isMobile ? <button type="button" onClick={() => setIsSearchOpen(true)} aria-label="Search messages in this wave" className="tw-flex tw-min-w-0 tw-items-center tw-border-0 tw-bg-transparent tw-p-0 tw-text-left"><div className="tw-size-6 tw-flex-shrink-0 tw-rounded-full tw-ring-1 tw-ring-white/30 tw-ring-offset-1 tw-ring-offset-iron-950 lg:tw-size-9"><WavePicture name={wave.name} picture={wave.picture} contributors={wave.contributors_overview.map(_temp3)} /></div><h1 className="tw-mb-0 tw-ml-3 tw-truncate tw-text-sm tw-font-semibold tw-tracking-tight tw-text-white/95 lg:tw-text-xl">{wave.name}</h1></button> : <><div className="tw-size-6 tw-flex-shrink-0 tw-rounded-full tw-ring-1 tw-ring-white/30 tw-ring-offset-1 tw-ring-offset-iron-950 lg:tw-size-9"><WavePicture name={wave.name} picture={wave.picture} contributors={wave.contributors_overview.map(_temp4)} /></div><h1 className="tw-mb-0 tw-ml-3 tw-truncate tw-text-sm tw-font-semibold tw-tracking-tight tw-text-white/95 lg:tw-text-xl">{wave.name}</h1><button type="button" onClick={() => setIsSearchOpen(true)} aria-label="Search messages in this wave" className="tw-ml-2 tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-900 tw-text-iron-200 tw-transition tw-duration-150 hover:tw-border-iron-500 hover:tw-bg-iron-800 hover:tw-text-white"><MagnifyingGlassIcon className="tw-h-4 tw-w-4 tw-flex-shrink-0" /></button></>;
    $[25] = isMobile;
    $[26] = wave.contributors_overview;
    $[27] = wave.name;
    $[28] = wave.picture;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== t10 || $[31] !== t11) {
    t12 = <div className="tw-flex tw-min-w-0 tw-items-center">{t10}{t11}</div>;
    $[30] = t10;
    $[31] = t11;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== wave) {
    t13 = <div className="tw-hidden lg:tw-block"><MyStreamWaveTabsMemeSubmit handleMemesSubmit={handleMemesSubmit} wave={wave} /></div>;
    $[33] = wave;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  const t14 = `tw-h-4 tw-w-4 tw-flex-shrink-0 tw-text-iron-200 tw-transition tw-duration-300 ${isRightSidebarOpen ? "tw-rotate-180 desktop-hover:group-hover:tw-translate-x-0.5" : "tw-rotate-0 desktop-hover:group-hover:-tw-translate-x-0.5"}`;
  let t15;
  if ($[35] !== t14) {
    t15 = <ChevronDoubleLeftIcon strokeWidth={2} className={t14} />;
    $[35] = t14;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== t15 || $[38] !== toggleRightSidebar) {
    t16 = <button type="button" onClick={toggleRightSidebar} className="tw-group tw-absolute tw-right-0 tw-top-1/2 tw-flex tw-h-8 tw-w-8 -tw-translate-y-1/2 tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-700 tw-shadow-[0_12px_28px_rgba(0,0,0,0.35)] tw-backdrop-blur-sm tw-transition tw-duration-300 tw-ease-out desktop-hover:hover:tw-border-iron-500/80 desktop-hover:hover:tw-bg-iron-700/85 desktop-hover:hover:tw-shadow-[0_16px_34px_rgba(0,0,0,0.4)]" aria-label="Toggle right sidebar">{t15}</button>;
    $[37] = t15;
    $[38] = toggleRightSidebar;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] !== t13 || $[41] !== t16) {
    t17 = <div className="tw-relative tw-flex tw-items-center tw-gap-x-2 tw-pr-10">{t13}{t16}</div>;
    $[40] = t13;
    $[41] = t16;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== t12 || $[44] !== t17) {
    t18 = <div className="tw-flex tw-items-center tw-justify-between tw-gap-x-4 tw-overflow-x-hidden tw-px-2 tw-py-3 sm:tw-px-4">{t12}{t17}</div>;
    $[43] = t12;
    $[44] = t17;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] !== activeContentTab || $[47] !== setActiveContentTab || $[48] !== wave) {
    t19 = <MyStreamWaveDesktopTabs activeTab={activeContentTab} wave={wave} setActiveTab={setActiveContentTab} />;
    $[46] = activeContentTab;
    $[47] = setActiveContentTab;
    $[48] = wave;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  let t20;
  if ($[50] !== isMemesWave || $[51] !== isRankWave || $[52] !== nextDecisionTime || $[53] !== timeLeft) {
    t20 = (isMemesWave || isRankWave) && nextDecisionTime && <div className="tw-flex-shrink-0 tw-px-2 sm:tw-px-4"><CompactTimeCountdown timeLeft={timeLeft} /></div>;
    $[50] = isMemesWave;
    $[51] = isRankWave;
    $[52] = nextDecisionTime;
    $[53] = timeLeft;
    $[54] = t20;
  } else {
    t20 = $[54];
  }
  let t21;
  if ($[55] !== t19 || $[56] !== t20) {
    t21 = <div className="tw-flex tw-items-center tw-justify-between tw-gap-4 tw-border-x-0 tw-border-y tw-border-solid tw-border-iron-800">{t19}{t20}</div>;
    $[55] = t19;
    $[56] = t20;
    $[57] = t21;
  } else {
    t21 = $[57];
  }
  let t22;
  if ($[58] !== t18 || $[59] !== t21) {
    t22 = <div className="tw-flex tw-w-full tw-flex-col tw-bg-iron-950">{t18}{t21}</div>;
    $[58] = t18;
    $[59] = t21;
    $[60] = t22;
  } else {
    t22 = $[60];
  }
  let t23;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = () => setIsMemesModalOpen(false);
    $[61] = t23;
  } else {
    t23 = $[61];
  }
  let t24;
  if ($[62] !== isMemesModalOpen || $[63] !== wave) {
    t24 = <MemesArtSubmissionModal isOpen={isMemesModalOpen} wave={wave} onClose={t23} />;
    $[62] = isMemesModalOpen;
    $[63] = wave;
    $[64] = t24;
  } else {
    t24 = $[64];
  }
  let t25;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = () => setIsSearchOpen(false);
    $[65] = t25;
  } else {
    t25 = $[65];
  }
  let t26;
  if ($[66] !== handleSearchSelect || $[67] !== isSearchOpen || $[68] !== wave) {
    t26 = <WaveDropsSearchModal isOpen={isSearchOpen} onClose={t25} wave={wave} onSelectSerialNo={handleSearchSelect} />;
    $[66] = handleSearchSelect;
    $[67] = isSearchOpen;
    $[68] = wave;
    $[69] = t26;
  } else {
    t26 = $[69];
  }
  let t27;
  if ($[70] !== t22 || $[71] !== t24 || $[72] !== t26) {
    t27 = <>{" "}{t22}{t24}{t26}</>;
    $[70] = t22;
    $[71] = t24;
    $[72] = t26;
    $[73] = t27;
  } else {
    t27 = $[73];
  }
  return t27;
};
export default MyStreamWaveTabsMeme;
function _temp(decision) {
  return {
    decision_time: decision.timestamp
  };
}
function _temp2(decision_1) {
  return decision_1.timestamp > Time.currentMillis();
}
function _temp3(c) {
  return {
    pfp: c.contributor_pfp
  };
}
function _temp4(c_0) {
  return {
    pfp: c_0.contributor_pfp
  };
}